<template>
    <div>
        <vForm :labelWidth="120" class="clearfix">
            <vCol span="12">
                <vFormItem
                    :label="
                        $t('boss.purchase.purchase_requisition_number', {
                            defaultValue: '采购申请单号',
                        })
                    "
                >
                    <Select
                        clearable
                        filterable
                        multiple
                        v-model="orderNo"
                        ref="zierpselect"
                        remote
                        :remote-method="remoteMethod1"
                        :loading="loading1"
                    >
                        <Option
                            v-for="json in purchaseList"
                            :value="json.label"
                            :key="json.value"
                            >{{ json.label }}</Option
                        >
                    </Select>
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vButton theme="primary" @click="search">{{
                    $t("boss.purchase.query", { defaultValue: "查询" })
                }}</vButton>
                <vButton class="margin-left-10" @click="clearbox">{{
                    $t("boss.purchase.clear", { defaultValue: "清空" })
                }}</vButton>
                <vButton
                    class="margin-left-10"
                    theme="success"
                    @click="importExcel"
                    >{{
                        $t("boss.purchase.info", { defaultValue: "导入" })
                    }}</vButton
                >
            </vCol>
        </vForm>
        <vTable
            class="margin-layout"
            :columns="columns"
            :data="datalist"
            ref="refwarehosue"
        ></vTable>
        <div class="text-right margin-10">
            {{ $t("boss.purchase.common", { defaultValue: "共" })
            }}{{ totallength }}
            {{ $t("boss.purchase.strip", { defaultValue: "条" }) }}
        </div>
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{
                $t("boss.purchase.sure", { defaultValue: "确定" })
            }}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{
                $t("boss.purchase.cancel", { defaultValue: "取消" })
            }}</vButton>
        </div>
        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                v-bind="getFileProps"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetApplicateList,
    HttpGetApplicateNos,
} from "@/service/purchase/purchase";

import { HttpGetErpsku } from "@/service/aftersales/aftersales";
import { HttpSysOpLog } from "@/service/boss/allot";
export default {
    props: ["orderid", "supplierId", "currency", "lineId"],
    data() {
        return {
            loading1: false,
            datalist: [],
            orderNo: [],
            purchaseList: [],
            totallength: 0,
            operate: {
                // id: null,
                title: "",
                show: false,
                actionurl: "",
                boxtype: "",
                downexcel: "",
                component: null,
            },
        };
    },
    components: {
        compTablelist: () => import("@components/templates/tablelist"),
        compUpload: () => import("@components/templates/upload"),
    },
    // created(){
    //     // this.update()
    // },
    computed: {
        columns() {
            let _this = this;
            return [
                {
                    title: "ERPSKU",
                    render(h, { row }) {
                        return <div>{row.erpsku}</div>;
                    },
                },
                {
                    title: this.$t(
                        "boss.purchase.purchase_requisition_number",
                        {
                            defaultValue: "采购申请单号",
                        }
                    ),
                    render(h, { row }) {
                        return <div>{row.poRequisitionOrderNo}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.expected_shelf_date", {
                        defaultValue: "预计上架日期",
                    }),
                    render(h, { row }) {
                        return <div>{row.expectedNeedDate}</div>;
                    },
                },
                // {
                // 	title: '采购数量',
                // 	render(h, { row }) {
                // 		return <div>{row.quantity}</div>
                // 	}
                // },
                {
                    title: this.$t(
                        "boss.purchase.actual_application_quantity_a",
                        {
                            defaultValue: "原申请数量/实际申请数量",
                        }
                    ),
                    render(h, { row }) {
                        return (
                            <div>
                                {row.quantity} / {row.symbalQty}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.currency_a", {
                        defaultValue: "参考单价/币种",
                    }),
                    render(h, { row }) {
                        return (
                            <div>
                                {row.price} / {row.currency}
                            </div>
                        );
                    },
                },
                {
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h(
                                "strong",
                                this.$t("boss.purchase.purchase_a", {
                                    defaultValue: "采购单价/币种",
                                })
                            ),
                        ]);
                    },
                    render: (h, { row, index }) => {
                        return h("div", [
                            h("Input", {
                                props: {
                                    size: "small",
                                    value: row.supplierProductPrice,
                                },
                                attrs: {
                                    style: "width: 70px;",
                                },
                                on: {
                                    input: (event) => {
                                        row.supplierProductPrice = event;
                                        this.datalist[index] = row;
                                    },
                                },
                            }),
                            h("span", ` / ${this.currency}`),
                        ]);
                    },
                },
                {
                    renderHeader: (h, params) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "ios-medical",
                                    color: "#ed3f14",
                                },
                            }),
                            h(
                                "strong",
                                this.$t(
                                    "boss.purchase.transfer_purchase_quantity",
                                    {
                                        defaultValue: "转采购数量",
                                    }
                                )
                            ),
                        ]);
                    },
                    render(h, { row, index }) {
                        return h("Input", {
                            props: {
                                size: "small",
                                value: row.buyquantity,
                            },
                            on: {
                                input: (event) => {
                                    row.buyquantity = event;
                                    _this.datalist[index] = row;
                                },
                            },
                        });
                    },
                },
                {
                    title: this.$t("boss.purchase.notes", {
                        defaultValue: "备注",
                    }),
                    render: (h, { row, index }) => {
                        return h("Input", {
                            props: {
                                size: "small",
                                value: row.remark,
                            },
                            on: {
                                input: (event) => {
                                    row.remark = event;
                                    this.datalist[index] = row;
                                },
                            },
                        });
                    },
                },
            ];
        },
        getFileProps() {
            if (this.operate.downexcel) {
                return {
                    data: {
                        supplierId: this.supplierId || 0,
                        currency: this.currency,
                    },
                    action:
                        process.env.VUE_APP_APIURL_BOSS +
                        this.operate.actionurl,
                    name: "excelFile",
                    download: () => {
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_BOSS +
                                this.operate.downexcel,
                            {},
                            "download"
                        );
                    },
                };
            } else {
                return {
                    data: {},
                    action:
                        process.env.VUE_APP_APIURL_BOSS +
                        this.operate.actionurl,
                    name: "excelFile",
                };
            }
        },
    },
    methods: {
        importExcel() {
            this.operate = {
                show: true,
                title: this.$t("boss.purchase.info", {
                    defaultValue: "导入",
                }),
                actionurl: "/api/v2/poRequisition/importItemExcelPoquisition",
                boxtype: "importexcel",
                downexcel: "/api/v2/poRequisition/downItemExcelPoquisition",
            };
        },
        // 点击上传附件之后的操作
        aaasuccess(res) {
            this.datalist = res.data.map((item) => {
                return {
                    erpsku: item.erpsku,
                    lineId: item.lineId,
                    poRequisitionOrderNo: item.poRequistionOrderNo,
                    poRequistionOrderId: item.poRequistionOrderId,
                    poRequistionOrderItemId: item.poRequistionOrderItemId,
                    expectedNeedDate: item.expectedNeedDate,
                    quantity: item.quantity < 0 ? 0 : item.quantity,
                    price: item.price,
                    currency: item.currency,
                    supplierProductPrice: item.poPrice || 0,
                    buyquantity: item.quantity < 0 ? 0 : item.quantity,
                    remark: item.remark,
                    productId: item.productId,
                };
            });
            this.cancelUpload();
        },
        cancelUpload() {
            this.operate.show = false;
        },
        remoteMethod1(query) {
            HttpGetApplicateList({
                "search[EQ_lineId]": this.lineId,
                "search[CN_orderNo]": query,
                rows: 10,
                "search[EQ_orderStatus]": "approved",
            }).then(
                (res) => {
                    this.purchaseList = res.data.content.map((item) => {
                        return { label: item.orderNo, value: item.id };
                    });
                },
                (err) => {
                    this.errorMessage(err.message);
                }
            );
        },
        search() {
            let idstring = this.orderNo;
            // console.log(this.$refs.refwarehosue)
            if (!idstring.length)
                return this.$VMessage.error(
                    this.$t("boss.purchase.document_first", {
                        defaultValue: "请先选择单据",
                    })
                );
            HttpGetApplicateNos({
                orderNos: idstring,
                supplierId: this.supplierId || 0,
                currency: this.currency,
            }).then(
                (res) => {
                    let attr = [];
                    res.data.map((item) => {
                        let oneitem = (item.poRequisitionItem || []).map(
                            (json) => {
                                return {
                                    lineId: item.lineId,
                                    poRequistionOrderId: item.id,
                                    poRequistionOrderItemId: json.id,
                                    poRequisitionOrderNo: item.orderNo,
                                    productId: json.productId,
                                    erpsku: json.erpsku,
                                    price: json.price,
                                    quantity: json.quantity,
                                    symbalQty:
                                        Number(json.quantity) -
                                            Number(json.cancelQuantity) <
                                        0
                                            ? 0
                                            : Number(json.quantity) -
                                              Number(json.cancelQuantity),
                                    currency: item.currency,
                                    refNo: item.refNo,
                                    usedQuantity: json.usedQuantity,
                                    supplierProductPrice:
                                        json.supplierProductPrice,
                                    buyquantity:
                                        Number(json.quantity) -
                                            Number(json.usedQuantity) -
                                            Number(json.cancelQuantity) <
                                        0
                                            ? 0
                                            : Number(json.quantity) -
                                              Number(json.usedQuantity) -
                                              Number(json.cancelQuantity),
                                    remark: item.remark,
                                    expectedNeedDate: json.expectedNeedDate,
                                };
                            }
                        );
                        attr.push(...oneitem);
                    });
                    // console.log(attr)
                    this.datalist = attr;
                    this.totallength = this.datalist.length;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        submit() {
            let flag = false;
            let numberflag = false;

            this.datalist.map((item, index) => {
                if (this.datalist[0].lineId !== this.datalist[index].lineId) {
                    // console.log(this.datalist[0].lineId,this.datalist[index].lineId,'lineId')
                    flag = true;
                }
                if (
                    Number(item.buyquantity) >
                        Number(item.quantity) -
                            Number(item.usedQuantity) -
                            Number(item.cancelQuantity) ||
                    Number(item.buyquantity) < 0
                ) {
                    numberflag = true;
                }
            });
            if (flag) {
                this.$VMessage.error(
                    this.$t("boss.purchase.selected_purchase_a", {
                        defaultValue:
                            "所选的采购申请单号项目不一致，不能添加，请重新选择！",
                    })
                );
                return;
            }
            if (numberflag) {
                this.$VMessage.error(
                    this.$t("boss.purchase.transfer_purchase_a", {
                        defaultValue:
                            "填写的转采购数量大于实际的数量或填写的转采购数量小于0，请重新填写！",
                    })
                );
                return;
            }

            // this.datalist = this.arrayUnique(this.datalist,'refNo')
            let poflag = false;
            let arraytab = [];
            this.datalist.map((item) => {
                // console.log(item.supplierProductPrice)
                if (
                    item.buyquantity > 0 &&
                    item.supplierProductPrice !== "" &&
                    item.supplierProductPrice != null
                ) {
                    arraytab.push(item);
                } else if (
                    item.buyquantity > 0 &&
                    (item.supplierProductPrice == "" ||
                        item.supplierProductPrice == null)
                ) {
                    poflag = true;
                }
            });

            if (poflag) {
                this.$VMessage.error(
                    this.$t("boss.purchase.purchase_price_a", {
                        defaultValue: "采购价格不能为空",
                    })
                );
                return;
            }

            let data = {
                datalist: arraytab,
                orderNos: this.orderNo,
            };

            this.$emit("on-updatecheck", data);
        },
        // 数组去重
        arrayUnique(arr, name) {
            var hash = {};
            return arr.reduce((item, next) => {
                hash[next[name]]
                    ? ""
                    : (hash[next[name]] = true && item.push(next));
                return item;
            }, []);
        },
        clearbox() {
            this.orderNo = [];
            this.datalist = [];
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
